
import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface InfoStepProps {
  name: string;
  setName: (name: string) => void;
  onContinue: (e: React.FormEvent) => void;
}

const InfoStep: React.FC<InfoStepProps> = ({ name, setName, onContinue }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim().length < 3) {
      alert("Veuillez entrer un nom valide d'au moins 3 caractères");
      return;
    }
    onContinue(e);
  };

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-center">Bienvenue sur EasyDJ+</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="name">Votre nom</Label>
              <Input 
                id="name" 
                placeholder="Entrez votre nom" 
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="h-12 text-base"
                required
              />
            </div>
            <Button type="submit" className="w-full h-12">
              Continuer
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default InfoStep;
